import { render, staticRenderFns } from "./MultipleGalleryUploadFile.vue?vue&type=template&id=3f8e6afc"
import script from "./MultipleGalleryUploadFile.vue?vue&type=script&lang=js"
export * from "./MultipleGalleryUploadFile.vue?vue&type=script&lang=js"
import style0 from "./MultipleGalleryUploadFile.vue?vue&type=style&index=0&id=3f8e6afc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports